import { __decorate } from "tslib";
import { Component } from '@angular/core';
export let AflaCommonComponent = class AflaCommonComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
AflaCommonComponent = __decorate([
    Component({
        selector: 'lib-afla-common',
        template: `
    <p>
      afla-common works!
    </p>
  `
    })
], AflaCommonComponent);
